import { DRIVER_OVERVIEW_REQUEST } from '../../actions/constants'; 

const initialState = {
  driver_overview : null 
}
const driverOverview = (state = initialState , action) => {
  switch (action.type) {
    case DRIVER_OVERVIEW_REQUEST : {
      const newState = Object.assign({},state,{
        driver_overview : action.payload
      })
      return newState;
    }
    default:
      return state;
  }
};
  
export default driverOverview;
  